<script setup lang="ts">
import type { DialogCloseProps } from 'reka-ui';
import { DialogClose } from 'reka-ui';

defineOptions({
    compatConfig: { MODE: 3 },
});

const props = defineProps<DialogCloseProps>();
</script>

<template>
    <DialogClose
        data-slot="dialog-close"
        v-bind="props"
    >
        <slot></slot>
    </DialogClose>
</template>
